import { render, staticRenderFns } from "./novel_long_series.vue?vue&type=template&id=24b0bc56&scoped=true"
import script from "./novel_long_series.vue?vue&type=script&lang=js"
export * from "./novel_long_series.vue?vue&type=script&lang=js"
import style0 from "./novel_long_series.vue?vue&type=style&index=0&id=24b0bc56&prod&lang=scss&scoped=true"
import style1 from "./novel_long_series.vue?vue&type=style&index=1&id=24b0bc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0bc56",
  null
  
)

export default component.exports